import { db } from "../../../config/firebase/firebase-config";
import { Office } from '../doc/OrganizationChart';
import { IValidateOffice } from "../form/IValidateOffice";
import { loadProductionOffices } from "./trdService";

// Agregar Oficina
export const addOffice = async (
  office: Office,
  idEntity: string,
  idProductionOffice: string
) => {

  await db
    .collection("Entities")
    .doc(idEntity)
    .collection("ProductionOffices")
    .doc(idProductionOffice)
    .collection("Offices")
    .doc(`${office.idOffice}`)
    .set({ ...office }, { merge: true });

};

// Cargar Oficinas de la oficina productoras
export const loadOffices = async (idEntity: string) => {
  const docRef = db
    .collection(`Entities`)
    .doc(idEntity)
    .collection("ProductionOffices");
  const offices = await loadProductionOffices(idEntity);

  // hacer consulta interna de cada oficina Data
  if (offices.length > 0) {
    const officesARR: any = [];
    for (let values of offices) {
      let officeSnap = await docRef.doc(values.id).collection("Offices").get();
      officeSnap.forEach((snapChild) => {
        officesARR.push({
          id: snapChild.id,
          ...snapChild.data(),
        });
      });
    }
    return officesARR;
  }

  return null;
};

// Editar Oficina en colección Offices
export const editOffice = async (data : IValidateOffice) => {
  await db
    .collection("Entities")
    .doc(`${data.idEntity}`)
    .collection("ProductionOffices")
    .doc(`${data.office.idProductionOffice}`)
    .collection("Offices")
    .doc(`${data.office.idOffice}`)
    .set(data.office, { merge: true });
};

// Borrar Oficina
export const deleteOfficeQuery = async (data : IValidateOffice) => {
  return db
    .collection("Entities")
    .doc(`${data.idEntity}`)
    .collection("ProductionOffices")
    .doc(`${data.office.idProductionOffice}`)
    .collection("Offices")
    .doc(`${data.office.idOffice}`)
    .delete();
};
